export default function fieldsetService() {
  return function generate(viewField, engineApi) {
    const element = engineApi.register.setCommonAttributes('ec-fieldset', viewField, engineApi).addAttribute('legend', viewField.title || ''),
      ecFlexRows = new engineApi.Element('ec-flex-rows');
    //
    element.append(ecFlexRows);
    ecFlexRows.append(engineApi.handleProperties(viewField, engineApi));
    return element;
  };
}
